// Auto-generated skeleton for History

export const History: Api.History = {
  id: 0,
  version_id: 0,
  sync_id: 0,
  model: '',
  model_data: '',
  model_id: 0,
  differences: null,
  created: null,
  updated: null,
};

